import React from "react";

import Layout from "../Layout/Layout";
import rapanalytical1 from "../assets/services/09.png";
import rapanalytical2 from "../assets/services/11.png";
import rapanalytical3 from "../assets/services/12.png";
import rapanalytical4 from "../assets/services/13.png";
import rapanalytical5 from "../assets/services/15.png";
import rapanalytical6 from "../assets/services/17.png";
import rapanalytical7 from "../assets/services/09.png";
import rapanalytical8 from "../assets/services/13.png";

import BreadCrumb from "../Breadcrumb/BreadCrumb";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { MetaTags } from "react-meta-tags";

const images = [
  rapanalytical1,
  rapanalytical2,
  rapanalytical3,
  rapanalytical4,
  rapanalytical5,
  rapanalytical6,
  rapanalytical7,
  rapanalytical8,
];

const services = [
  {
    tag: "Precision powered by HPLC",
    title: "Analytical Excellence",
    points: [
      "Custom HPLC method development",
      "ICH compliant method validation",
      "Stability indicating methods",
      "High sensitivity & reproducibility",
      "Degradation studies",
      "Method optimization using QBD",
      "ANOVA of response factors",
      "Identifying & controlling critical method parameters",
    ],
  },
  {
    tag: "Accelerating discovery with reliable bioanalysis",
    title: "Bioanalytical Methods",
    points: [
      "Method development for small & large molecules",
      "Bioanalytical validations per international guidelines",
      "Stability studies",
      "LC-MS/MS expertise",
      "FDA, EMA & ICH aligned validation",
    ],
  },
  {
    tag: "Advancing innovation through trusted preclinical animal models",
    title: "Animal Studies",
    points: [
      "Pharmacokinetic studies",
      "Efficacy testing",
      "Method development & validation",
      "Toxicological evaluations",
      "Risk assessment",
      "Safety reports",
    ],
  },
  {
    tag: "Building a safer path to humans",
    title: "Pre-clinical Studies",
    points: [
      "Pharmacokinetic assessments",
      "Efficacy studies & biological outcomes",
      "Analytical method development & validation",
      "Toxicology studies",
      "Structured risk evaluations",
      "Submission-ready safety reports",
    ],
  },
  {
    tag: "Your complete work plan",
    title: "Research Methodology",
    points: [
      "Literature survey",
      "API selection",
      "Research hypothesis",
      "Research work & thesis write-up",
      "Referencing & appendix",
      "Publication & certification",
    ],
  },
  {
    tag: "Beyond analysis — driving petrochemical process",
    title: "Gas Chromatography",
    points: [
      "Comprehensive analysis of petrochemical compounds",
      "Custom method development",
      "Trace level detection",
      "Process optimization support",
      "R&D collaboration",
    ],
  },
  {
    tag: "Hands-on & academic-industrial programs",
    title: "Training Courses",
    points: [
      "Hands-on training on analytical instruments",
      "Standard operating procedure & theory lectures",
      "Qualitative & quantitative analysis",
      "Troubleshooting & industrial documentation",
      "GMP / GLP / GDP guidelines",
      "Certificate on completion",
    ],
  },
  {
    tag: "Bridging theory and practical application",
    title: "Workshop & Seminars",
    points: [
      "Advanced analytical techniques & instrumentation insights",
      "Method development strategies & data interpretation",
      "Scientific writing & research publication",
      "Innovation management & IP awareness",
      "Regulatory understanding",
      "Entrepreneurship development",
    ],
  },
].map((service, index) => ({
  ...service,
  image: images[index % images.length],
}));

function Service() {
  return (
    <>
      <MetaTags>
        <title>Service | RAP </title>
        <meta name="RAP Analytical" content="RAP Analytical" />
      </MetaTags>
      <BreadcrumbsItem to={"/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={"/service"}>Service</BreadcrumbsItem>

      <Layout>
        <BreadCrumb name="Service" />

        <section className="rap-services">
          <span className="rap-services__blob rap-services__blob--teal-1" />
          <span className="rap-services__blob rap-services__blob--gold" />
          <span className="rap-services__blob rap-services__blob--teal-2" />
          <span className="rap-services__blob rap-services__blob--navy" />

          <div className="rap-services__intro container">
            <span className="rap-services__bar" />
            <h2 className="rap-services__heading">Services</h2>
            <p className="rap-services__lead">
              A seamless, end-to-end project management experience covering
              every facet of your research — from method design through
              regulatory-ready results, backed by advanced analytical tools
              and a learner-centric approach.
            </p>
          </div>

          <div className="rap-services__grid container">
            {services.map((service) => (
              <div className="rap-service-card" key={service.title}>
                <div className="rap-service-card__photo">
                  <img src={service.image} alt={service.title} />
                </div>
                <span className="rap-service-card__tag">{service.tag}</span>
                <h3 className="rap-service-card__title">{service.title}</h3>
                <span className="rap-service-card__rule" />
                <ul className="rap-service-card__list">
                  {service.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </Layout>

      <style>{`
        .rap-services {
          position: relative;
          overflow: hidden;
          background: #f4f9f8;
          padding: 68px 0 90px;
        }

        .rap-services__blob {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
          z-index: 0;
        }

        .rap-services__blob--teal-1 {
          width: 220px;
          height: 220px;
          top: -90px;
          right: -70px;
          background: #17a398;
          opacity: 0.14;
        }

        .rap-services__blob--gold {
          width: 140px;
          height: 140px;
          bottom: 60px;
          left: -60px;
          background: #e0a83e;
          opacity: 0.16;
        }

        .rap-services__blob--teal-2 {
          width: 90px;
          height: 90px;
          bottom: -30px;
          right: 12%;
          background: #17a398;
          opacity: 0.12;
        }

        .rap-services__blob--navy {
          width: 260px;
          height: 260px;
          top: 40%;
          left: -140px;
          background: #0d3b4f;
          opacity: 0.06;
        }

        .rap-services__intro {
          position: relative;
          z-index: 1;
          max-width: 720px;
          margin: 0 auto 50px;
          text-align: center;
        }

        .rap-services__bar {
          display: inline-block;
          width: 34px;
          height: 5px;
          border-radius: 3px;
          background: #e0a83e;
          margin-bottom: 16px;
        }

        .rap-services__heading {
          font-size: 36px;
          font-weight: 800;
          color: #0d3b4f;
          margin: 0 0 6px;
          line-height: 1.2;
          text-decoration: underline;
          text-decoration-color: #17a398;
          text-decoration-thickness: 3px;
          text-underline-offset: 8px;
        }

        .rap-services__lead {
          font-size: 16px;
          line-height: 1.75;
          color: #4a5c62;
          margin: 22px 0 0;
        }

        .rap-services__grid {
          position: relative;
          z-index: 1;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
        }

        @media (max-width: 1100px) {
          .rap-services__grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 620px) {
          .rap-services__grid {
            grid-template-columns: 1fr;
          }
          .rap-services__heading {
            font-size: 27px;
          }
        }

        .rap-service-card {
          position: relative;
          background: #ffffff;
          border-radius: 20px;
          overflow: hidden;
          border: 1px solid #e3edeb;
          box-shadow: 0 2px 10px rgba(13, 59, 79, 0.05);
          transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
          display: flex;
          flex-direction: column;
          text-align: left;
        }

        .rap-service-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 32px rgba(13, 59, 79, 0.14);
          border-color: #17a398;
        }

        .rap-service-card__photo {
          width: 100%;
          height: 280px;
          border-bottom: 4px solid #17a398;
          overflow: hidden;
          background: #0d3b4f;
        }

        @media (max-width: 620px) {
          .rap-service-card__photo {
            height: 220px;
          }
        }

        .rap-service-card__photo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          pointer-events: none;
        }

        .rap-service-card__tag {
          display: block;
          margin: 22px 26px 8px;
          font-size: 11.5px;
          font-weight: 700;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: #e0a83e;
        }

        .rap-service-card__title {
          font-size: 19px;
          font-weight: 800;
          color: #0d3b4f;
          margin: 0 26px;
          line-height: 1.3;
        }

        .rap-service-card__rule {
          display: block;
          width: 30px;
          height: 3px;
          border-radius: 2px;
          background: #17a398;
          margin: 10px 26px 16px;
        }

        .rap-service-card__list {
          list-style: none;
          margin: 0 26px 30px;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 9px;
        }

        .rap-service-card__list li {
          position: relative;
          padding-left: 18px;
          font-size: 14.5px;
          line-height: 1.5;
          color: #3d4d52;
        }

        .rap-service-card__list li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 7px;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #17a398;
        }
      `}</style>
    </>
  );
}

export default Service;